import Layout from "@/views/layout";
import WebLayout from "@/views/web/layout";

const loginRouter = {
  path: "/",
  redirect: "/login",
  component: WebLayout,
  children: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login")
    },
    {
      path: "/rwa/joint-login",
      name: "rwaJointLogin",
      component: () => import("@/views/rwa/JointLogin.vue")
    },
    {
      path: "/notFound",
      name: "notFound",
      component: () => import("@/views/otherView/notFound")
    }
  ]
};

const exceptionTask = [
  {
    path: "/exceptionTask",
    name: "exceptionTask",
    component: () => import("@/views/exception")
  }
];

export const appRouters = [
  {
    path: "/",
    redirect: "/login",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import(/* webpackChunkName: "home" */ "@/views/home"),
        meta: {
          title: "home",
          iconfont: "iconhomepage",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/declare",
    name: "declare",
    component: Layout,
    children: [
      {
        name: "declareList",
        path: "/declareList",
        component: () => import("@/views/declare"),
        meta: {
          title: "declare",
          iconfont: "iconOlder",
          noCache: true,
          btnPermission: ["restApply"]
        }
      },
      {
        name: "declareDetail",
        hidden: true,
        path: "/declareDetail/:id",
        component: () => import("@/views/declare/DeclareDetail"),
        meta: {
          title: "declareDetail",
          btnPermission: [
            "updatePayerInfo",
            "updateConsigneeInfo",
            "updateBusinessState"
          ]
        }
      }
    ]
  },
  {
    path: "/declareManage",
    name: "declareManage",
    component: Layout,
    children: [
      {
        name: "declareOrderImport",
        path: "/declareOrderImport",
        component: () => import("@/views/customs_declare/CustomsDeclareImport"),
        meta: {
          title: "declareOrderImport",
          iconfont: "iconOlder",
          noCache: true
        }
      },
      {
        name: "declareOrderList",
        path: "/declareOrderList",
        component: () => import("@/views/customs_declare"),
        meta: {
          title: "declareOrderList",
          iconfont: "iconOlder",
          noCache: true,
          btnPermission: ["restApply"]
        }
      },
      {
        name: "customsDeclareDetail",
        hidden: true,
        path: "/customsDeclareDetail/:id",
        component: () => import("@/views/customs_declare/CustomsDeclareDetail"),
        meta: {
          title: "customsDeclareDetail",
          btnPermission: [
            "updatePayerInfo",
            "updateConsigneeInfo",
            "updateBusinessState"
          ]
        }
      }
    ]
  },

  {
    path: "/taxesCommerce",
    name: "taxesCommerce",
    component: Layout,
    meta: {
      title: "taxesCommerce",
      iconfont: "iconOlder",
      noCache: true
    },
    children: [
      {
        name: "taxCommerceAccountList",
        path: "/taxCommerceAccountList",
        component: () =>
          import("@/views/taxes_commerce/TaxesCommerceAccountList.vue"),
        meta: {
          title: "taxCommerceAccountList",
          iconfont: "iconOlder",
          noCache: true
        }
      },
      {
        name: "taxesCommerceRechargeDetailList",
        path: "/taxesCommerceRechargeDetailList",
        component: () =>
          import("@/views/taxes_commerce/TaxesCommerceRechargeDetailList.vue"),
        meta: {
          title: "taxesCommerceRechargeDetailList",
          iconfont: "iconOlder",
          noCache: true
        }
      },
      {
        name: "taxesCommerceExpenseCalendarList",
        path: "/taxesCommerceExpenseCalendarList",
        component: () =>
          import("@/views/taxes_commerce/TaxesCommerceExpenseCalendarList.vue"),
        meta: {
          title: "taxesCommerceExpenseCalendarList",
          iconfont: "iconOlder",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/stockControlList_layout",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/stockControl",
        name: "stockControl",
        component: () =>
          import(/* webpackChunkName: "download" */ "@/views/stockControl"),
        meta: {
          title: "stockControl",
          iconfont: "iconEdit",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/carrier_layout",
    component: Layout,
    children: [
      {
        path: "/carrierList",
        name: "carrierList",
        component: () =>
          import(/* webpackChunkName: "download" */ "@/views/carrier"),
        meta: {
          title: "carrierList",
          iconfont: "iconEdit",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/role_layout",
    component: Layout,
    children: [
      {
        path: "/roleView",
        name: "roleView",
        component: () => import("@/views/role"),
        meta: {
          title: "roleView",
          iconfont: "iconEdit",
          noCache: true
        }
      }
    ]
  },

  {
    path: "/oms_user_layout",
    component: Layout,
    children: [
      {
        path: "/oms_user_list",
        name: "omsUserList",
        component: () =>
          import(/* webpackChunkName: "download" */ "@/views/oms_user"),
        meta: {
          title: "omsUserList",
          iconfont: "iconEdit",
          noCache: true,
          btnPermission: ["create"]
        }
      }
    ]
  },
  {
    path: "/change_password",
    component: Layout,
    children: [
      {
        path: "/change_password",
        name: "changePassword",
        component: () =>
          import(/* webpackChunkName: "download" */ "@/views/change_password"),
        meta: {
          title: "changePwd",
          iconfont: "iconEdit",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/download",
    component: Layout,
    children: [
      {
        path: "/downloadList",
        name: "download",
        component: () =>
          import(/* webpackChunkName: "download" */ "@/views/download"),
        meta: {
          title: "downloadList",
          iconfont: "iconDownload_form",
          noCache: true
        }
      }
    ]
  }
];

export default [
  loginRouter
  //...webRouters,
  //...mobileRouters,
  //mLoginRouter
];
